export const EXTERNAL_LINKS = {
  mainSite: 'https://admesh.in',
  terms: 'https://admesh.in/terms.html',
  privacy: 'https://admesh.in/privacy.html',
  supportEmail: 'support@admesh.in',
  githubRepo: 'https://github.com/Sonsilicon/AdMesh',
  githubIssues: 'https://github.com/Sonsilicon/AdMesh/issues/new/choose',
  discordForum: 'https://discord.gg/mnw9RNb5dY',
  docs: 'https://dev.admesh.in/docs',
  devPortal: 'https://dev.admesh.in',
  advertiserPortal: 'https://app.admesh.in',
} as const;

export function getDeveloperPortalOrigin(): string {
  return window.location.origin;
}
